import * as domtree from './tree';
import * as domevents from './events';

let components = [];
const map = new WeakMap();


//is a node completely in the dom? if we can find a sibling anywhere, it must be closed
function isNodeCompletelyInDom(node)
{
  for(;node;node=node.parentNode)
    if(node.nextSibling)
      return true;
  return false;
}
function processRegistration(item, reg, domready)
{
  if(!domready && !isNodeCompletelyInDom(item))
    return; //not safe to register

  if (!map.has(item))
    map.set(item, [ reg.num ]);
  else
  {
    let list = map.get(item);
    if (list.includes(reg.num))
      return;
    list.push(reg.num);
  }
  reg.handler(item, reg.index++); //note: if an exception is reported from Object.handler,
}
function applyRegistration(reg, startnode)
{
  let domready = domtree.isDomReady();
  if(reg.afterdomready && !domready)
    return;

  let items = Array.from( (startnode || document).querySelectorAll(reg.selector));
  if(startnode && domtree.matches(startnode,reg.selector))
    items.unshift(startnode);

  items.forEach(item =>
  {
    try
    {
      processRegistration(item, reg, domready);
    }
    catch(e)
    {
      console.error("Exception handling registration of",item,"for rule",reg.selector);
      console.log("Registration",reg);
      console.log(e,e.stack);
    }
  });
}

/* A focus implementation that allows the node to intercept focused, allowing eg
   radio/checkbox replacements to redirect focus but also explicitly preventing
   focus of a disabled element */
export function focusElement(node)
{
  if(node.disabled)
    throw new Error("Cannot focus a disabled element");

  if(!domevents.dispatchCustomEvent(node, 'dompack:takefocus', { bubbles: true, cancelable: true }))
    return;

  try
  {
    node.focus();
  }
  catch(e)
  {
  }
}

/** @short Register a component for auto-initialization.
    @param selector Selector the component must match
    @param handler Handler
    @param options Any unrecognized options are passed to the handler

    The handler will be invoked with two parameters
    - the node to register
    - the index of the node (a unique counter for this selector - first is 0) */

export function register(selector, handler, options)
{
  let newreg = { selector: selector
               , handler: handler
               , index: 0
               , num: components.length
               , afterdomready: !options || options.afterdomready
               };
  if(components.length==0 && !domtree.isDomReady()) //first component... we'll need a ready handler
    domtree.onDomReady(() => registerMissed());

  components.push(newreg);
  applyRegistration(newreg, null);
}

// register any components we missed on previous scans
export function registerMissed(startnode)
{
  let todo = components.slice(0);
  todo.forEach(item => applyRegistration(item, startnode));
}



// WEBPACK FOOTER //
// /opt/wh/whtree/~/dompack/src/components.es